import type { CarouselApi } from '@/components/_ui/Carousel'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/_ui/Carousel'
import React, { useState, useEffect, type ReactElement } from 'react'
import T from '@/components/Helpers/Translate'
import type CartSheetRecommendedProductsCarouselItem from '../CarouselItem'

const CartSheetRecommendedProductsCarousel = ({
  children,
}: {
  children:
    | ReactElement<typeof CartSheetRecommendedProductsCarouselItem>
    | Array<ReactElement<typeof CartSheetRecommendedProductsCarouselItem>>
}) => {
  const [api, setApi] = useState<CarouselApi>()
  const [current, setCurrent] = useState(0)
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!api) {
      return
    }

    setCount(api.scrollSnapList().length)
    setCurrent(api.selectedScrollSnap() + 1)

    api.on('select', () => {
      setCurrent(api.selectedScrollSnap() + 1)
    })
  }, [api])

  if (!children) return <div>No Products</div>

  return (
    <Carousel
      setApi={setApi}
      opts={{
        align: 'start',
      }}
    >
      <CarouselContent>
        {React.Children.map(children, (child, index) => (
          <CarouselItem key={index} className="sm:basis-1/2">
            {child}
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className="block py-2 text-center text-sm text-muted-foreground sm:hidden">
        <T>slide</T> {current} <T>of</T> {count}
      </div>
    </Carousel>
  )
}
export default CartSheetRecommendedProductsCarousel
